import { Component, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DialogService {
    private activeComponent$: BehaviorSubject<Component>;
    private maintenance$: BehaviorSubject<boolean>;
    private dialogData: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    get opened() {
        return this.activeComponent$.value;
    }

    get dialogData$() {
        return this.dialogData.asObservable();
    }

    constructor() {
        this.activeComponent$ = new BehaviorSubject(null);
        this.maintenance$ = new BehaviorSubject(false);
    }

    displayComponent(component: any) {
        this.activeComponent$.next(component);
    }

    hideDialog() {
        this.activeComponent$.next(null);
    }

    activeComponent(): Observable<any> {
        return this.activeComponent$.asObservable();
    }

    setMaintenanceMode(enabled: boolean) {
        this.maintenance$.next(enabled);
    }

    getMaintenanceMode(): Observable<any> {
        return this.maintenance$.asObservable();
    }

    setDialogData(data: any) {
        this.dialogData.next(data);
    }
}
